import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TAB_LOCK_HOLDER_ID } from '../ticket-lock-holder';

/**
 * Dice al backend da quale scheda parte la modifica di un ticket, così può verificare che il blocco
 * di modifica sia di chi sta salvando.
 */
@Injectable()
export class TicketLockHolderInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method === 'PATCH' && request.url.startsWith(`${environment.baseUrl}/ticket/`)) {
      return next.handle(request.clone({ setHeaders: { 'X-Lock-Holder': TAB_LOCK_HOLDER_ID } }));
    }
    return next.handle(request);
  }
}
